import IC_CLOUD from "@/assets/flow/ic_cloud.svg?react";
import dataFolwStore from "@/store/endSideFlow.store";
import { DataFlowApis, ScreenShareRecorder } from "@core/ability";
import { Circle } from "rc-progress";
import { useEffect, useRef, useState } from "react";
import { isNetNormal, uploadRecord } from "@/services/endsize_flow";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import fridayReporter from "@/utils/friday";

interface IProp {
  screenShareRecorder: ScreenShareRecorder;
  doneCallback: () => void;
}


export function ProcessView(prop: IProp) {
  const navigate = useNavigate();

  const remoteIp = dataFolwStore((store) => store.remoteIp);
  const remotePort = dataFolwStore((store) => store.remotrPort);
  const isClound = dataFolwStore((store) => store.isCloud);
  const uploadProcess = dataFolwStore((store) => store.uploadProcess);
  const jsonFilePath = dataFolwStore((store) => store.jsonFilePath);
  const waitRetryUpload = dataFolwStore((store) => store.waitRetryUpload);

  const [percent, setPercent] = useState(0);
  // const [rotate, setRotate] = useState(-360 * 0);
  const [title, setTitle] = useState('拉取到本地');
  const [isPull, setIsPull] = useState(true);

  const downloadProcessUnsubscription = useRef<() => void>();
  const downloadStatusUnsubscription = useRef<() => void>();

  useEffect(() => {
    if (waitRetryUpload) {
      saveRecord(jsonFilePath);
      setIsPull(false);
      setPercent(0);
      setTitle('保存到Maxhub会记');
    } else {
      startDownload();
    }

    return () => {
      downloadProcessUnsubscription.current?.();
      downloadStatusUnsubscription.current?.();
    }
  }, []);

  const startDownload = async () => {
    downloadProcessUnsubscription.current = DataFlowApis.downloadProcess((data) => {
      console.log('downloadProcess', data.data.progress);
      setPercent(data.data.progress);
      // setRotate(-360 * data.data.progress);
    });
    downloadStatusUnsubscription.current = DataFlowApis.downloadStatus((data) => {
      console.log('downloadStatus', data.data.event);
      console.log('downloadStatus', data.data.data.filePath);
      if (data.data.event === "success") {
        console.log('文件拉取成功，解压进行下一步操作');
        unzipFile(data.data.data.filePath);
      } else {
        console.log('文件拉取失败，改变状态');
      }
      prop.screenShareRecorder.handleDisconnect();
    });
    const fileName = `CurrentAIMeeting${Date.parse(new Date().toString())}.zip`;

    const res = await DataFlowApis.downloadMeeting(remoteIp!, remotePort!, '.\\AIMeeting\\CurrentAIMeeting.zip', fileName);
    if (!res) {
      console.log('下载失败，改变状态');
      prop.screenShareRecorder.handleDisconnect();
      dataFolwStore.getState().changeSection(4);
    }
  }

  const unzipFile = async (zipPath: string) => {
    const res = await DataFlowApis.uzipMeetingFile(zipPath, dataFolwStore.getState().localFileSavePath);
    await DataFlowApis.deleteFile(zipPath); // 删除源zip文件
    if (res.length > 0) {
      let customJsonPath: string | undefined = undefined;
      for (let i = 0; i < res.length; i++) {
        if (res[i].endsWith('.json')) {
          customJsonPath ??= res[i];
          dataFolwStore.getState().setJsonPath(customJsonPath);
        }
        if (res[i].endsWith('.wav')) {
          dataFolwStore.getState().setAudioPath(res[i]);
        }
      }
      console.log(res);
      if (isClound) {
        setPercent(0);
        setTitle('保存到Maxhub会记');
        await saveRecord(customJsonPath);
      } else {
        console.log('customJsonPath = ', customJsonPath);
        // 删除掉json文件即可
        customJsonPath && await DataFlowApis.deleteFile(customJsonPath);
        message.success('保存成功');
        prop.doneCallback();
      }
    } else {
      dataFolwStore.getState().changeSection(4);
      console.log('文件解压失败，改变状态');
    }
  }

  const handleSaveRecordError = () => {
    fridayReporter.pushData({
      eventCode: "HomePage_GetFiles_SaveCloud_GetStatus",
      payload: {
        get_status: "fail",
      },
    });
    dataFolwStore.getState().changeSection(4);
  }

  const saveRecord = async (customJsonPath: string | undefined) => {
    if (customJsonPath) {
      const jsonData = await DataFlowApis.parseMeetingJson(customJsonPath);
      console.log('解析json文件成功');
      if (jsonData && jsonData != "") {
        if (!await isNetNormal()) {
          dataFolwStore.getState().setRetryUpload(true);
          handleSaveRecordError();
        } else {
          const streamName = await uploadRecord(jsonData);
          if (streamName) {
            dataFolwStore.getState().setStreamName(streamName);
            setTitle('上传音频文件');
            setIsPull(false);
            dataFolwStore.getState().uploadAudioForStream(uploadCallback);
          } else {
            handleSaveRecordError();
          }
        }
      } else {
        console.error('json数据位空，认为事变，改变状态');
        handleSaveRecordError();
      }
    } else {
      console.error('解压后的文件中找不到json结尾的文件，认为失败，改变状态');
      handleSaveRecordError();

    }
  }

  const uploadCallback = (event: string) => {
    dataFolwStore.getState().setRetryUpload(false);
    if (event === "success") {
      fridayReporter.pushData({
        eventCode: "HomePage_GetFiles_SaveCloud_GetStatus",
        payload: {
          get_status: "success",
        },
      });
      message.success('数据同步成功');
      navigate({ pathname: "/summary", search: `?streamId=${dataFolwStore.getState().streamName!.replace("live/", "")}` });
      prop.doneCallback();
    } else {
      fridayReporter.pushData({
        eventCode: "HomePage_GetFiles_SaveCloud_GetStatus",
        payload: {
          get_status: "fail",
        },
      });
      message.error('数据同步失败');
      prop.doneCallback();
    }
  }

  return (
    <div className="flex flex-col items-center mt-9">
      <div className="relative w-16 h-16">
        <IC_CLOUD className="w-8 h-8 absolute left-1/2 top-1/2 -translate-1/2"></IC_CLOUD>
        {isPull ?
          <Circle className="w-16 h-16" percent={percent * 100} strokeWidth={6} strokeColor="#4981F2" trailWidth={6} trailColor="#ECEEF3"></Circle> :
          <Circle className="w-16 h-16" percent={uploadProcess} strokeWidth={6} strokeColor="#4981F2" trailWidth={6} trailColor="#ECEEF3"></Circle>}
      </div>
      <span className="text-size-4 text-black mt-6 font-bold">{title}</span>
      <span className="text-size-3 text-mx-quaternary mt-2">同步过程请勿离开MAXHUB大屏</span>
    </div>
  );
}